module.exports = __webpack_public_path__ + "static/img/21.35c0797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/21.png
// module id = g1tw
// module chunks = 0